import { render, staticRenderFns } from "./DocumentByProDatatableComponent.vue?vue&type=template&id=0dca2ea3&"
import script from "./DocumentByProDatatableComponent.vue?vue&type=script&lang=js&"
export * from "./DocumentByProDatatableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports